<template>
  <div class="container">
    <br />
    <router-link to="/broadcaster/events">[Back to Events]</router-link>
    <br />
    <br />
    <h2>{{ event.eventName }}</h2>

    <hr />
    <div class="mobile-grid">
      <button @click="goToRemoteScoreboard" class="btn btn-dark">
        Remote Scoreboard
      </button>
      <a class="btn btn-dark" v-bind:href="'/broadcaster/editEvent/' + event.id"
        >Edit Event</a
      >
      <button @click="deleteEvent" class="btn btn-danger">Delete Event</button>
    </div>
    <br />
    <br />

    <event :event="event" :channel_id="channel.id"> </event>
    <br />
    <div v-if="event" class="seasoncast-card">
      <h5>Details</h5>
      <p>
        Event Name: {{ event.eventName }}<br />
        Date: {{ new Date(event.timeStart * 1000).toLocaleDateString() }} |
        {{
          new Date(event.timeStart * 1000).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })
        }}<br />
        Timeline Events: {{ event.events ? event.events.length : 0 }}<br />
        Is Live: {{ event.isActive ? "Yes" : "No" }}<br />
      </p>
    </div>

    <br />

    <div class="seasoncast-card table-responsive">
      <h5>Recordings</h5>

      <table class="table">
        <thead class="thead-light">
          <tr>
            <th scope="col">Session</th>
            <th scope="col">Time</th>
            <th scope="col">Duration</th>
            <th scope="col">Saved</th>
            <th scope="col">Link</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="recording in event.recordings"
            v-bind:key="recording.session"
          >
            <th scope="row">{{ recording.session }}</th>
            <td>{{ new Date(recording.onPub).toLocaleTimeString() }}</td>
            <td>{{ (recording.duration / 60.0).toFixed(1) + " min" }}</td>
            <td>{{ recording.status == 0 ? "Yes" : "No" }}</td>
            <td>
              <a v-bind:href="'/broadcaster/recording/' + recording.session"
                >View</a
              >
            </td>
          </tr>
        </tbody>
      </table>

      <hr />
      <div>
        <div class="p-2 seasoncast-card m-2">
          <h5>Recording Uploader</h5>
          <hr />
          <ul>
            <li v-for="file in files" v-bind:key="file.id">
              {{ file.name }} - Status:
              {{
                file.error
                  ? "Error: " + file.error
                  : file.success
                  ? "Uploaded"
                  : file.active
                  ? file.progress +
                    "% " +
                    Math.floor(file.speed / 1024 / 1024) +
                    " MB/s"
                  : "Ready to upload"
              }}
              <button
                type="button"
                v-if="!file.success && !file.active"
                @click.prevent="$refs.upload.remove(file)"
              >
                Remove
              </button>
            </li>
          </ul>

          <fileUpload
            ref="upload"
            v-model="files"
            :multiple="true"
            :drop="true"
            post-action="https://app.seasoncast.com/v2/broadcaster/event/upload"
            :data="{
              ...this.$store.state.broadcasterAuth,
              event_id: this.event.id,
            }"
            @input-file="inputFile"
            @input-filter="inputFilter"
          >
            <button type="button" class="btn btn-link">+ Add file</button> or
            drag and drop a mp4 file
          </fileUpload>
          <br />

          <button
            v-show="
              $refs.upload && !$refs.upload.active && !$refs.upload.uploaded
            "
            @click.prevent="$refs.upload.active = true"
            class="btn btn-dark"
            type="button"
          >
            Start upload
          </button>
          <button
            v-show="$refs.upload && $refs.upload.active"
            @click.prevent="$refs.upload.active = false"
            class="btn btn-dark"
            type="button"
          >
            Stop upload
          </button>
        </div>
      </div>
    </div>
    <br />
    <div v-if="event" class="seasoncast-card">
      <h5>Broadcast to Event</h5>
      <p>
        1. Use the SeasonCast mobile app to broadcast [Use 'Select Event' in
        app]<br />
        2. Use 3rd party RTMP encoder (Scoreboard Graphics Generated by
        SeasonCast)<br />
        3. Use 3rd party RTMP encoder (Scoreboard Graphics Generated by Encoder
        or No Graphics)
        <br /><br />
        <small>
          Note: If using a 3rd Party RTMP Encoder, please use 'Remote
          Scoreboard' to control the scoreboard graphics and/or stats.</small
        >
      </p>
    </div>
    <br />
    <div v-if="event" class="seasoncast-card">
      <h5>RTMP Encoder Settings for 3rd Party Source</h5>
      <br />
      <div v-if="channel.premium.active">
        <p>
          <b>Location:</b><br />
          <select class="form-control" v-model="selectedServer">
            <option v-for="(item, key) in serverList" :value="key" :key="key">
              {{ item.name + " (" + item.short_name + ")" }}
            </option>
            <option
              disabled
              v-for="(item, key) in serverListDown"
              :value="serverList.length + key"
              :key="serverList.length + key"
            >
              {{ item.name + " (" + item.short_name + ") - " + item.reason }}
            </option>
            <option disabled v-if="serverList.length == 1">
              Loading All Available Servers...
            </option></select
          ><br />
          <b>RTMP URL (None or Encoder Graphics):</b><br /><small
            ><code> {{ serverList[selectedServer].url }}</code></small
          ><br /><br />
          <b>RTMP URL (SeasonCast Scoreboard Generated Graphics):</b><br />
          <small
            ><code> {{ serverList[selectedServer].graphical }}</code></small
          ><br /><br />
          <b>Stream Key:</b><br />
          <span v-if="!token">
            <small
              ><code>
                {{ event.id }}?email={{ email }}&key={{ key }}</code
              ></small
            >
            <br />
            <br />
            <small
              ><button @click="copyS()" class="btn btn-dark">
                Copy Entire RTMP (GoPro, Yi)
              </button></small
            >
          </span>
          <span v-else>
            <small
              ><code>
                {{ event.id }}?email={{ channel.email }}&key={{
                  channel.key
                }}</code
              ></small
            >
            <br />
            <br />
            <small
              ><button @click="copyS()" class="btn btn-dark">
                Copy Entire RTMP (GoPro, Yi)
              </button></small
            >
          </span>
          <br /><br />
          <small
            >Some encoders only take one value. In this case, use 'copy entire
            RTMP' or combine the URL and stream key with a slash ( / ) manually.
            For generated graphics, please use 1280x720 as the
            resolution.</small
          >
        </p>
      </div>
      <div v-else>
        <p>Upgrade to Premium to use RTMP feature</p>
      </div>

      <small>
        Note: SeasonCast enforces copyright and DMCA policies strictly. Do not
        re-broadcast content you did not create (example: A TV Broadcast).
        Unauthorized streams will be taken down within 10 minutes, and legal
        action may be pursued against responsible parties.
      </small>
    </div>

    <br />
    <div v-if="event" class="seasoncast-card">
      <chart
        :eventData="event"
        v-if="event.events"
        :teams="event.teams"
      ></chart>
    </div>
    <br />
  </div>
</template>

<script>
import axios from "axios";
import cookie from "cookie.js";
import copy from "copy-to-clipboard";
import Swal from "sweetalert2";
import fileUpload from "vue-upload-component";
import event from "../Event.vue";
import chart from "../gamebee/chart.vue";
let API = "https://app.seasoncast.com/";

export default {
  name: "Home",
  props: ["channel"],
  components: {
    event,
    chart,
    fileUpload: fileUpload,
  },

  data: function () {
    return {
      event,
      selectedServer: 0,
      serverList: [
        {
          name: "New York City, NY",
          short_name: "NY-2",
          type: "RTMP",
          version: 1.1,
          url: "rtmp://ny-2.ingest.seasoncast.com/ingest/",
          graphical: "rtmp://ny-2.ingest.seasoncast.com/graphical/",
          ping: "http://ny-2.ingest.seasoncast.com:3000/",
        },
      ],
      files: [],
      serverListDown: [],
      showUploadComp: false,
    };
  },
  created: async function () {
    this.email = cookie.get("broadcaster-email");
    this.key = cookie.get("broadcaster-key");
    this.token = cookie.get("broadcaster-token");
    await this.getChannelEvent();
    this.getServerList();
  },
  methods: {
    copyS: async function () {
      copy(
        this.serverList[this.selectedServer].graphical +
          this.event.id +
          "?email=" +
          this.email +
          "&key=" +
          this.key
      );
    },
    getChannelEvent: async function () {
      let getEventResponse = await axios.post(API + "v2/channel/event", {
        channel_id: this.channel.id,
        event_id: this.$route.params.option,
      });

      let responseData = getEventResponse.data;

      if (!responseData.success) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "message: " + JSON.stringify(responseData.reason),
          footer: "Try action later or refresh page",
        });
      }
      console.log(responseData);
      this.event = responseData.eventData;

      if (this.event.deleted) {
        this.event = undefined;
        await Swal.fire({
          icon: "info",
          title: "This event was deleted!",
          text: "This event no longer exist",
        });
        this.$router.push("/broadcaster/events");
      }
    },
    getRTMPServers: async function () {},
    goToRemoteScoreboard: async function () {
      let getEventResponse = await axios.post(
        API + "v2/broadcaster/event/pin",
        {
          ...this.$store.state.broadcasterAuth,
          event_id: this.$route.params.option,
        }
      );

      let responseData = getEventResponse.data;

      if (!responseData.success) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "message: " + JSON.stringify(responseData.reason),
          footer: "Try action later or refresh page",
        });
      }
      console.log(responseData);

      await Swal.fire({
        icon: "info",
        title: "You are going to Remote Scoreboard",
        text: "Event Pin: " + responseData.pin,
      });

      window.location = "https://lockerstats.com/" + responseData.pin;
    },
    deleteEvent: async function () {
      if (this.event.recordings.length != 0) {
        await Swal.fire({
          icon: "info",
          title: "Need to delete all recordings",
          text: "You need to delete all recordings tied to this event before deleting!",
          showConfirmButton: true,
        });
        return;
      }

      let userConfirm = await Swal.fire({
        icon: "warning",
        title: "Confirm Event Delete",
        text: "You are about to delete this event",
        showCancelButton: true,
        confirmButtonText: `Delete`,
      });
      if (!userConfirm.isConfirmed) {
        return;
      }

      await axios.post(API + "v2/broadcaster/event/delete", {
        ...this.$store.state.broadcasterAuth,
        event_id: this.$route.params.option,
      });

      //let responseData = getEventResponse.data

      //if (!responseData.success){return}

      this.getChannelEvent();
    },
    getServerList: async function () {
      let getEventResponse = await axios.post(
        API + "v2/broadcaster/getServerList",
        {
          ...this.$store.state.broadcasterAuth,
        }
      );

      let responseData = getEventResponse.data;

      if (!responseData.success) {
        return;
      }
      this.serverList = responseData.servers;
      this.serverListDown = responseData.down_servers;
    },
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log("response", newFile.response);
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(mp4)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
  },
};
</script>
<style lang="scss">
.container {
  max-width: 1100px;
}
</style>
